import styled from "styled-components";
import { Link } from "react-router-dom";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  background: #3cc830;
  width: 100%;
  height: 100vh;
  border-radius: 10px;
  justify-content: ;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease-in-out;

  div {
    margin: 0 auto;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const CardTitle = styled.p`
  color: #fff;
  font-size: 36px;
  font-weight: 500;
`;

export const CardDetail = styled.div``;

export const CardList = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  text-decoration: none;
  color: #fff;
  font-size: 2.4rem;

  img {
    border-radius: 50%;
  }
  :hover {
    transform: scale(1.1);
    color: #005900;
  }
`;
